/** @module my_constants */

export const FETCH_BROKER_FIRMS_REQUEST = 'FETCH_BROKER_FIRMS_REQUEST';
export const FETCH_BROKER_FIRMS_SUCCESS = 'FETCH_BROKER_FIRMS_SUCCESS';
export const FETCH_BROKER_FIRMS_FAILURE = 'FETCH_BROKER_FIRMS_FAILURE';
export const DELETE_BROKER_FIRM_REQUEST = 'DELETE_BROKER_FIRM_REQUEST';
export const DELETE_BROKER_FIRM_SUCCESS = 'DELETE_BROKER_FIRM_SUCCESS';
export const DELETE_BROKER_FIRM_FAILURE = 'DELETE_BROKER_FIRM_FAILURE';
export const UPDATE_BROKER_FIRM_REQUEST = 'UPDATE_BROKER_FIRM_REQUEST';
export const UPDATE_BROKER_FIRM_SUCCESS = 'UPDATE_BROKER_FIRM_SUCCESS';
export const UPDATE_BROKER_FIRM_FAILURE = 'UPDATE_BROKER_FIRM_FAILURE';
export const CREATE_BROKER_FIRM_REQUEST = 'CREATE_BROKER_FIRM_REQUEST';
export const CREATE_BROKER_FIRM_SUCCESS = 'CREATE_BROKER_FIRM_SUCCESS';
export const CREATE_BROKER_FIRM_FAILURE = 'CREATE_BROKER_FIRM_FAILURE';
export const CREATE_BROKER_FIRM_RESETSTATE = "CREATE_BROKER_FIRM_RESETSTATE";

export const FETCH_BROKER_USERS_REQUEST = 'FETCH_BROKER_USERS_REQUEST';
export const FETCH_FILTER_BROKER_USERS_REQUEST = 'FETCH_FILTER_BROKER_USERS_REQUEST';
export const FETCH_BROKER_USERS_SUCCESS = 'FETCH_BROKER_USERS_SUCCESS';
export const FETCH_BROKER_USERS_FAILURE = 'FETCH_BROKER_USERS_FAILURE';
export const DELETE_BROKER_USER_REQUEST = 'DELETE_BROKER_USER_REQUEST';
export const DELETE_BROKER_USER_SUCCESS = 'DELETE_BROKER_USER_SUCCESS';
export const DELETE_BROKER_USER_FAILURE = 'DELETE_BROKER_USER_FAILURE';
export const UPDATE_BROKER_USER_REQUEST = 'UPDATE_BROKER_USER_REQUEST';
export const UPDATE_BROKER_USER_SUCCESS = 'UPDATE_BROKER_USER_SUCCESS';
export const UPDATE_BROKER_USER_FAILURE = 'UPDATE_BROKER_USER_FAILURE';
export const CREATE_BROKER_USER_REQUEST = 'CREATE_BROKER_USER_REQUEST';
export const CREATE_BROKER_USER_SUCCESS = 'CREATE_BROKER_USER_SUCCESS';
export const CREATE_BROKER_USER_FAILURE = 'CREATE_BROKER_USER_FAILURE';

export const FETCH_BROKER_FIRM_OWNERS_REQUEST =
    'FETCH_BROKER_FIRM_OWNERS_REQUEST';
export const FETCH_BROKER_FIRM_OWNERS_SUCCESS =
    'FETCH_BROKER_FIRM_OWNERS_SUCCESS';
export const FETCH_BROKER_FIRM_OWNERS_FAILURE =
    'FETCH_BROKER_FIRM_OWNERS_FAILURE';
